import {Component, Input, OnInit} from '@angular/core';
import {FormGroup, Validators} from '@angular/forms';
import {EformService} from "../../../service/eform.service";

@Component({
   selector: 'app-phone-number',
   templateUrl: './phone-number.component.html',
   styleUrls: ['./phone-number.component.css']
})
export class PhoneNumberComponent implements OnInit {
   @Input() field: any = {};
   @Input() form: FormGroup;
   @Input() checkValidate: any;
   @Input() fieldName: any;
   @Input() labelName: any;
   @Input() hideHeader: boolean = false;
   placeholder: string;
   defaultExample: string;
   value: any;

   constructor(private eformService: EformService) {}

   ngOnInit(): void {
      this.value = this.eformService.eForm.value.value && this.eformService.eForm.value.value[this.fieldName] ? this.eformService.eForm.value.value[this.fieldName] : this.value;
      if (this.field.type === 'mobile') {
         this.placeholder = 'xxx-xxx-xxxx';
         this.defaultExample = '098-000-0000';
         this.field.required ? this.form.controls[this.fieldName].setValidators([Validators.required, Validators.pattern('(\\d{3}- ?)\\d{3}-\\d{4}')])
            : this.form.controls[this.fieldName].setValidators(Validators.pattern('(\\d{3}- ?)\\d{3}-\\d{4}'));
      } else if (this.field.type === 'landline_type1') {
         this.placeholder = 'xx-xxx-xxxx';
         this.defaultExample = '02-000-0000';
         this.field.required ? this.form.controls[this.fieldName].setValidators([Validators.required, Validators.pattern('(\\d{2}- ?)\\d{3}-\\d{4}')])
            : this.form.controls[this.fieldName].setValidators(Validators.pattern('(\\d{2}- ?)\\d{3}-\\d{4}'));
      } else if (this.field.type === 'landline_type2') {
         this.placeholder = '+xx xx-xxx-xxxx';
         this.defaultExample = '+66 00-000-0000';
         this.field.required ? this.form.controls[this.fieldName].setValidators([Validators.required, Validators.pattern('(\\+\\d{2} ?)\\d{2}-\\d{3}-\\d{4}')])
            : this.form.controls[this.fieldName].setValidators(Validators.pattern('(\\+\\d{2} ?)\\d{2}-\\d{3}-\\d{4}'));
      } else {
         this.placeholder = 'xxx-xxx-xxx';
         this.defaultExample = '032-000-000';
         this.field.required ? this.form.controls[this.fieldName].setValidators([Validators.required, Validators.pattern('(\\d{3}- ?)\\d{3}-\\d{3}')])
            : this.form.controls[this.fieldName].setValidators(Validators.pattern('(\\d{3}- ?)\\d{3}-\\d{3}'));
      }
   }

   onChange(event) {
    let value = event.target.value;
    let numericValue = value.replace(/\D/g, '');
    let formattedValue = '';

    if (this.field.type === 'mobile') {
        // Format: xxx-xxx-xxxx
        if (numericValue.length > 0) {
            formattedValue = `${numericValue.substring(0, 3)}`;
            if (numericValue.length > 3) {
                formattedValue += `-${numericValue.substring(3, 6)}`;
            }
            if (numericValue.length > 6) {
                formattedValue += `-${numericValue.substring(6, 10)}`;
            }
        }
    } else if (this.field.type === 'landline_type1') {
        // Format: xx-xxx-xxxx
        if (numericValue.length > 0) {
            formattedValue = `${numericValue.substring(0, 2)}`;
            if (numericValue.length > 2) {
                formattedValue += `-${numericValue.substring(2, 5)}`;
            }
            if (numericValue.length > 5) {
                formattedValue += `-${numericValue.substring(5, 9)}`;
            }
        }
    } else if (this.field.type === 'landline_type2') {
        // Format: +xx xx-xxx-xxxx
        if (numericValue.length > 0) {
            formattedValue = `+${numericValue.substring(0, 2)}`;
            if (numericValue.length > 2) {
                formattedValue += ` ${numericValue.substring(2, 4)}`;
            }
            if (numericValue.length > 4) {
                formattedValue += `-${numericValue.substring(4, 7)}`;
            }
            if (numericValue.length > 7) {
               formattedValue += `-${numericValue.substring(7, 11)}`;
            }
        }
    } else {
      // xxx-xxx-xxx
      if (numericValue.length > 0) {
         formattedValue = `${numericValue.substring(0, 3)}`;
         if (numericValue.length > 3) {
             formattedValue += `-${numericValue.substring(3, 6)}`;
         }
         if (numericValue.length > 6) {
             formattedValue += `-${numericValue.substring(6, 9)}`;
         }
     }
    }
    if (formattedValue !== value) {
        this.form.controls[this.fieldName].setValue(formattedValue, { emitEvent: false });
    }
}

   getMaxLength() {
      if (this.field.type === 'mobile') {
         return 12;  // ใช้สำหรับ xxx-xxx-xxxx
      } else if (this.field.type === 'landline_type1') {
         return 11;  // ใช้สำหรับ xx-xxx-xxxx
      } else if (this.field.type === 'landline_type2') {
         return 15;  // ใช้สำหรับ +xx xx-xxx-xxxx
      } else {
         return 11;  // ใช้สำหรับ xxx-xxx-xxx
      }
   }

   isEmpty(value: any): boolean {
      return value == null || value === '';
   }
}
